import { create } from 'zustand'
import axios from 'axios'
import fileDownload from 'js-file-download'

interface FileDownloadStore {
	download(url: string, filename: string): Promise<{ success: boolean; data: any }>
}

export const useFileDownloadStore = create<FileDownloadStore>((set, get) => ({
	download: async (url: string, filename: string) => {
		try {
			const res = await axios.get(url, {
				responseType: 'blob',
			})
			fileDownload(res.data, filename)
			return { success: true, data: res.data }
		} catch (err: any) {
			return {
				success: false,
				data: err?.response?.data?.message?.toString(),
			}
		}
	},
}))
